/** Aceita "42" ou "#42"; retorna null se vazio ou inválido. */
export function parseRequestNumberFilter(value: string | null | undefined): number | null {
  const digits = (value || '').replace(/\D/g, '')
  if (!digits) return null
  const n = Number(digits)
  if (!Number.isFinite(n) || n <= 0) return null
  return n
}
